module.exports = __webpack_public_path__ + "img/icon-title-back.b4cad3cd.png";